import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import TopClinicalTrialsWrapper from "@components/layouts/topClinicalTrialsWrapper";

export default function TopCommercialCleanersHome(): ReactElement {
    return (
        <TopClinicalTrialsWrapper>
            <PrivacyPolicy
                category="Clinical Trials"
                domain="TopClinicalTrials.com"
            />
        </TopClinicalTrialsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
